import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { OuterLayout } from '../styles/Layouts';
import bg from '../assets/bg.svg';

function SupportRequest() {
  return (
    <SupportRequestStyled
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0, transition: { duration: 0.5 } }}
    >
      <OuterLayout></OuterLayout>
    </SupportRequestStyled>
  );
}

const SupportRequestStyled = styled(motion.div)`
  min-height: 100vh;
  width: 100%;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 100%;
`;

export default SupportRequest;
